// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-B9o","top":"styles_top__1MOAE","left":"styles_left__1L-_r","description":"styles_description__HwvpI"};